import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import AlertReducer from './reducers/AlertReducer';
import AttendanceReducer from './reducers/AttendanceReducer';
import AuthenticationActivityReducer from './reducers/authenticationActivity';
import boxPressedProcessReducer from './reducers/boxPressedProcess';
import CigarsReducer from './reducers/cigar';
import CigarPerformanceReducer from './reducers/cigarPerformance';
import CigarProductionPlansReducer from './reducers/cigarProductionPlans';
import cigarRecipeForTooltipReducer from './reducers/cigarRecipeForTooltip';
import CigarRollPricesReducer from './reducers/cigarRollPrices';
import CigarUnitBoxReducer from './reducers/cigarUnitBoxProduction';
import CigarUnitProductionReducer from './reducers/cigarUnitProduction';
import CigarUnitReducer from './reducers/CigarUnitReducer';
import ConveyorCigarUnitProductionsReducer from './reducers/ConveyorCigarUnitProductionsReducer';
import conveyorsMenuReducer from './reducers/conveyorsMenu';
import ConveyorStepRecordsReducer from './reducers/conveyorStepRecords';
import ConveyorTemplateReducer from './reducers/conveyorTemplate';
import conveyorTransactionsReducer from './reducers/conveyorTransactions';
import CycleCounts from './reducers/cycleCount';
import DashboardReducer from './reducers/dashboard';
import DepartmentReducer from './reducers/department';
import DepartmentRequestReducer from './reducers/departmentRequest';
import DistributorsReducer from './reducers/distributors';
import EmployeesReducer from './reducers/EmployeesReducer';
import EmployeeTasksReducer from './reducers/employeeTasks';
import EmployeeTeamsReducer from './reducers/employeeTeams';
import EmployeeUnitProductionsReducer from './reducers/EmployeeUnitProductionsReducer';
import ExpensesReducer from './reducers/ExpensesReducer';
import factoryFilesReducer from './reducers/factoryFiles';
import FactoryOptionsReducer from './reducers/factoryOptions';
import FactoryReducer from './reducers/FactoryReducer';
import FinishedGoodInventoryReducer from './reducers/finishedGoodInventory';
import FinishedGoodTemplate from './reducers/finishedGoodTemplate';
import GiftSummaryReducer from './reducers/giftSummary';
import OnlineUsersReducer from './reducers/onlineUsers';
import PackingListReducer from './reducers/packingList';
import pageIndicatorsReducer from './reducers/pageIndicators';
import pairCigarAssignmentsReducer from './reducers/pairCigarAssignments';
import PaymentCodeCigarsMappingReducer from './reducers/paymentCodeCigarMapping';
import PayrollReducer from './reducers/PayrollReducer';
import PurchaseOrderReducer from './reducers/purchaseOrder';
import qrCodesReducer from './reducers/QrCodesReducer';
import qrPdfTemplatesReducer from './reducers/qrPdfTemplates';
import RawMaterialInventoryReducer from './reducers/rawMaterialInventory';
import RoomsReducer from './reducers/rooms';
import schedulerTasksReducer from './reducers/schedulerTasks';
import SessionReducer from './reducers/SessionReducer';
import SettingsReducer from './reducers/SettingsReducer';
import SuppliersReducer from './reducers/suppliers';
import TaxesReducer from './reducers/taxes';
import TobaccoContainers from './reducers/tobaccoContainers';
import tobaccoCorrectionsReducer from './reducers/tobaccoCorrections';
import tobaccoCostReducer from './reducers/tobaccoCost';
import TobaccoDryRoomProductionReducer from './reducers/tobaccoDryProduction';
import TobaccoGaleraProductionReducer from './reducers/tobaccoGaleraProduction';
import TobaccoHumidityRoomProductionReducer from './reducers/tobaccoHumidificationProduction';
import TobaccoInventoryReducer from './reducers/tobaccoInventory';
import tobaccoMappingsReducer from './reducers/tobaccoMappings';
import TobaccoProductionReducer from './reducers/tobaccoProduction';
import TobaccoProductionCorrectionReducer from './reducers/tobaccoProductionCorrection';
import TobaccosReducer from './reducers/tobaccos';
import TobaccoSalesReducer from './reducers/tobaccoSales';
import TobaccoTransactionsReducer from './reducers/tobaccoTransactions';
import TobaccoTransferSummaryReducer from './reducers/tobaccoTransferSummary';
import tobaccoWorkOrdersReducer from './reducers/tobaccoWorkOrders';
import UserActivityReducer from './reducers/userActivity';
import UserNotificationsReducer from './reducers/userNotifications';
import UsersReducer from './reducers/users';
import userWhiteListReducer from './reducers/userWhiteList';
import WorkInProgressInventoryReducer from './reducers/workInProgressInventory';
import WorkOrdersReducer from './reducers/workOrders';

// Middlewares
// import persistMiddleware, { reHydrateStore } from './middlewares/persistMiddleware';

// ------------------------------------------------------

export const store = configureStore({
  reducer: {
    alert: AlertReducer,
    settings: SettingsReducer,
    userNotifications: UserNotificationsReducer,
    session: SessionReducer,
    dashboard: DashboardReducer,
    factory: FactoryReducer,
    authenticationActivity: AuthenticationActivityReducer,
    userActivity: UserActivityReducer,
    onlineUsers: OnlineUsersReducer,
    users: UsersReducer,
    employees: EmployeesReducer,
    employeeTeams: EmployeeTeamsReducer,
    attendance: AttendanceReducer,
    cigarUnitProduction: CigarUnitProductionReducer,
    cigarPerformance: CigarPerformanceReducer,
    cigarProductionPlans: CigarProductionPlansReducer,
    employeeTasks: EmployeeTasksReducer,
    tobaccoProduction: TobaccoProductionReducer,
    tobaccoDryProduction: TobaccoDryRoomProductionReducer,
    tobaccoHumidificationProduction: TobaccoHumidityRoomProductionReducer,
    tobaccoProductionCorrection: TobaccoProductionCorrectionReducer,
    tobaccoTransferSummary: TobaccoTransferSummaryReducer,
    tobaccoGaleraProduction: TobaccoGaleraProductionReducer,
    tobaccoTransactions: TobaccoTransactionsReducer,
    conveyorCigarUnitProductions: ConveyorCigarUnitProductionsReducer,
    employeeUnitProductions: EmployeeUnitProductionsReducer,
    payroll: PayrollReducer,
    expenses: ExpensesReducer,
    cigars: CigarsReducer,
    cigarRecipeForTooltip: cigarRecipeForTooltipReducer,
    cigarRollPrices: CigarRollPricesReducer,
    cigarUnit: CigarUnitReducer,
    cigarUnitBox: CigarUnitBoxReducer,
    paymentCodeCigarsMapping: PaymentCodeCigarsMappingReducer,
    inventory: WorkInProgressInventoryReducer,
    finishedGoodInventory: FinishedGoodInventoryReducer,
    rawMaterialInventory: RawMaterialInventoryReducer,
    packingList: PackingListReducer,
    departmentRequest: DepartmentRequestReducer,
    departments: DepartmentReducer,
    workOrders: WorkOrdersReducer,
    suppliers: SuppliersReducer,
    taxes: TaxesReducer,
    purchaseOrder: PurchaseOrderReducer,
    rooms: RoomsReducer,
    distributors: DistributorsReducer,
    factoryOptions: FactoryOptionsReducer,
    factoryFiles: factoryFilesReducer,
    qrPdfTemplates: qrPdfTemplatesReducer,
    tobaccos: TobaccosReducer,
    tobaccoInventory: TobaccoInventoryReducer,
    tobaccoContainers: TobaccoContainers,
    tobaccoCorrections: tobaccoCorrectionsReducer,
    conveyorStepRecords: ConveyorStepRecordsReducer,
    conveyorTemplates: ConveyorTemplateReducer,
    tobaccoSales: TobaccoSalesReducer,
    cycleCounts: CycleCounts,
    finishedGoodTemplate: FinishedGoodTemplate,
    boxPressedProcess: boxPressedProcessReducer,
    tobaccoCost: tobaccoCostReducer,
    userWhiteList: userWhiteListReducer,
    tobaccoMappings: tobaccoMappingsReducer,
    pageIndicators: pageIndicatorsReducer,
    schedulerTasks: schedulerTasksReducer,
    conveyorsMenu: conveyorsMenuReducer,
    conveyorTransactions: conveyorTransactionsReducer,
    giftSummary: GiftSummaryReducer,

    qrCodes: qrCodesReducer,
    tobaccoWorkOrders: tobaccoWorkOrdersReducer,
    pairCigarAssignments: pairCigarAssignmentsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  // preloadedState: reHydrateStore(),
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware({
  // 	immutableCheck: { ignoredPaths: ['formPages'] },
  // 	serializableCheck: { ignoredPaths: ['formPages'] }
  // }).concat(persistMiddleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Create typed hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
